import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    show: false,
    title: '',
    data: [],
    loading: false
};

export const stillageWidgetModalSlice = createSlice({
    name: 'stillageWidgetModal',
    initialState,
    reducers: {
        openModal: (state, action) => {
            const { title = '', data = [], loading = false } = action.payload || {};
            state.show = true;
            state.title = title;
            state.data = data;
            state.loading = loading;
        },
        closeModal: (state) => {
            state.show = false;
            state.title = '';
            state.data = [];
            state.loading = false;
        }
    }
});

// Action creators are generated for each case reducer function
export const { openModal, closeModal } = stillageWidgetModalSlice.actions;

export default stillageWidgetModalSlice.reducer;